<template>
	<div>
		<v-list-item link :disabled="!detail.enabled" :to="detail.to">
			<!--<v-list-item-icon />-->
			<v-list-item-content>
				<v-list-item-title class="pl-2">{{ detail.title }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-list-item link :disabled="!detail.enabled" :to="detail.to" :key="detail.title" v-for="detail in pinned_abook_worklists">
			<!--<v-list-item-icon />-->
			<v-list-item-content>
				<v-list-item-title class="pl-2">- {{ detail.title }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
	</div>
</template>

<script>
export default {
	props: {
		detail: {
			type: Object,
			default: null
		},
		color: {
			type: String,
			default: "black"
		}
	},
	computed: {
		pinned_abook_worklists() {
			return this.$store.state.pinned_abook_worklists;
		}
	},
}	
</script>